export const CHANGE_PARAMS = 'location/CHANGE_PARAMS';
export const CHANGE_QUERY = 'location/CHANGE_QUERY';
export const CHANGE_NON_QUERY = 'location/CHANGE_NON_QUERY';
